const NS = 'SiteHeader';
const CLS = 'siteHeader';

export class SiteHeader {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.init();
	}

	init() {
		$('.hasnav').each((i, el) => {
			let navid = $(el).data('nav');
			$(el).on('click', () => {
				this.openNav(navid);
			});
		});

		$('.sidenav-back').each((i, el) => {
			let navid = $(el).data('nav');
			$(el).on('click', () => {
				this.closeNav(navid);
			});
		});

		$('.closebtn').on('click', () => {
			$('.siteHeader-sidenav').css('left', '-100%');
			$('.siteHeader-top').removeClass('fix');
		});

		$('.siteHeader-search-pc .search-btn').on('click', () => {
			$('.siteHeader-search-pc input').removeClass('d-none');
			$('.siteHeader-search-pc input').focus();
			$('.siteHeader-search-pc .search-btn').addClass('d-none');
		});

		$('.siteHeader-language').on('click', (e) => {
			$('.siteHeader-language').toggleClass('active inactive');
		});
	}

	openNav(navid) {
		document.getElementById(navid).style.left = '0%';
		$('.siteHeader-top').addClass('fix');
	}

	closeNav(navid) {
		document.getElementById(navid).style.left = '-100%';
	}
}
